import { render, staticRenderFns } from "./PolizasIEListView.vue?vue&type=template&id=773ef663&"
import script from "./PolizasIEListView.vue?vue&type=script&lang=js&"
export * from "./PolizasIEListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports